// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Y-sC","questions":"styles_questions__1R5az","footer":"styles_footer__OnIqp"};